import React, { useState, useContext, useEffect, useMemo } from 'react';
import {
	ButtonWrapper,
	DateRangeWrapper,
	DateRangeWrapperSpendByYear,
	FiltersWrapper,
	InputWrapper,
	KpiGridContainer,
	Label,
	Ribbon,
	RibbonText,
	SmallInputWrapper,
	SpendByYearFilter,
	SupplierLandscapeFilter,
	TableWrapper,
	SourceableTotalSpendOptionWrapper,
	DirectIndirectOptionsWrapper,
	ToggleWrapper,
	TooltipContent,
	Wrapper,
	TaxonomyTypeOptionWrapper,
	NoDataWrapper,
} from './Dashboard.styles';
import {
	ApButtonIcon,
	ApButtonSecondary,
	ApIcon,
	ApInput,
	ApSimpleDropdown,
	ApToggleSwitch,
	colors,
} from '@alixpartners/ui-components';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import { isUndefined } from 'lodash';
import MonthPicker from 'Settings/FirstUsageSettings/MonthPicker';
import ToggleSidebar from 'CategoryManagement/Components/ToggleSidebar/ToggleSidebar';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { Select } from 'CategoryManagement/Select';
import { Tooltip } from 'react-tippy';
import ChartsWrapper from './ChartsWrapper';
import KpiList from 'CategoryManagement/Components/KpiList/KpiList';
import CategorySidebarContent from 'CategoryManagement/Components/CategorySidebarContent/CategorySidebarContent';
import { useSupplierLandscapeContext } from 'contexts/CategoryDashboardCharts/SupplierLandscapeProvider';
import { useSpendBySubCategoryContext } from 'contexts/CategoryDashboardCharts/SpendBySubCategoryProvider';
import { useVendorsBySpendContext } from 'contexts/CategoryDashboardCharts/VendorsBySpendProvider';
import { useSpendByCountryContext } from 'contexts/CategoryDashboardCharts/SpendByCountryProvider';
import { useVendorSpendByCategoryContext } from 'contexts/CategoryDashboardCharts/VendorSpendByCategoryProvider';
import { useVendorParetoContext } from 'contexts/CategoryDashboardCharts/VendorParetoProvider';
import { useSpendByBusinessUnitContext } from 'contexts/CategoryDashboardCharts/SpendByBusinessUnitProvider';
import { useSpendByCostCenterContext } from 'contexts/CategoryDashboardCharts/SpendByCostCenterProvider';
import { useDaysPaidOutstandingContext } from 'contexts/CategoryDashboardCharts/DaysPaidOutstandingProvider';
import { useSpendOverTimeContext } from 'contexts/CategoryDashboardCharts/SpendOverTimeProvider';
import LoadingIndicator from 'components/LoadingIndicator';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { updateCategoryInsightSettings } from 'utils/apiRequests';
import { useCustomChartContext } from 'contexts/CategoryDashboardCharts/CustomChartProvider';
import { SettingsContext } from 'contexts/SettingsContext';
import { usePaymentTermBySupplierContext } from 'contexts/CategoryDashboardCharts/PaymentTermBySupplierProvider';
import { useCommonSuppliersContext } from 'contexts/CategoryDashboardCharts/CommonSupplierProvider';
import {
	allOption,
	AP_CATEGORIES,
	APCategoryMapper,
	CLIENT_CATEGORIES,
	ClientCategoryMapper,
	DEFAULT_CUSTOM_COLUMNS,
	DirectIndirectOptions,
	DirectTaxonomyTypeOptions,
	HEADER_HEIGHT,
	IndirectTaxonomyTypeOptions,
	ROW_HEIGHT,
	SourceableTotalSpendOptions,
	TAXONOMY_TYPES,
} from '../utils';
import NoData from 'CategoryManagement/NoData';

export const DEFAULTCATEGORY = 'L4';
export const DEFAULTUNIT = 'm';

const Dashboard = () => {
	const {
		currentSelectCategory,
		dateRangeData,
		handleDateRangeChange,
		isDirect,
		isSourceable,
		taxonomyType,
		handleSourceableTotalSpendChange,
		handleDirectIndirectChange,
		dateRangeDataSpendByYear,
		handleDateRangeChangeForSpendByYear,
		handleTaxonomyTypeChange,
		kpi,
	} = useContext(CategoryManagementContext);
	const { data } = kpi;

	const {
		isLoading: spendBySubCategoryLoading,
	} = useSpendBySubCategoryContext();
	const { isLoading: vendorsBySpendLoading } = useVendorsBySpendContext();
	const { isLoading: spendByCountryLoading } = useSpendByCountryContext();
	const {
		isLoading: vendorSpendByCategoryLoading,
	} = useVendorSpendByCategoryContext();
	const { isLoading: vendorParetoContextLoading } = useVendorParetoContext();
	const { isLoading: supplierLandscapeLoading } = useSupplierLandscapeContext();
	const {
		isLoading: spendByBusinessUnitLoading,
	} = useSpendByBusinessUnitContext();
	const { isLoading: spendByCostCenterLoading } = useSpendByCostCenterContext();
	const {
		isLoading: daysPaidOutstandingLoading,
	} = useDaysPaidOutstandingContext();
	const { isLoading: spendOverTimeLoading } = useSpendOverTimeContext();
	const {
		isLoading: paymentTermSupplierLoading,
	} = usePaymentTermBySupplierContext();
	const { isLoading: commonSuppliersLoading } = useCommonSuppliersContext();
	const {
		unit,
		value,
		category,
		UNITS,
		changeCategory,
	} = useSupplierLandscapeContext();
	const { customColId, setCustomColumnID } = useCustomChartContext();
	const { customFilters } = useContext(SettingsContext);
	const [isCategorySidebar, setIsCategorySidebar] = useState(false);
	const [isFilterSidebar, setIsFilterSidebar] = useState(false);
	const [isSettingSidebar, setIsSettingSidebar] = useState(false);
	const [customFiters, setCustomFilters] = useState([]);
	const { dashBoardSettings, handleSaveDashboardSettings } = useContext(
		CategoryInsightsSettingsContext
	);
	const [chartsOption, setChartsOption] = useState(dashBoardSettings);
	useEffect(
		() => {
			setChartsOption(dashBoardSettings);
		},
		[dashBoardSettings]
	);
	useEffect(
		() => {
			setCustomFilters(
				customFilters
					.map((data, key) => ({ value: data.label, key: key + 1, ...data }))
					.filter(data => data.isActive)
			);
		},

		[customFilters]
	);

	const toggleValue = index => {
		setChartsOption(prevItems => {
			const updatedItems = [...prevItems];
			updatedItems[index] = {
				...updatedItems[index],
				show: !updatedItems[index].show,
			};
			return updatedItems;
		});
	};

	const onGridReady = params => params.api.sizeColumnsToFit();

	const columnDefs = [
		{
			field: 'title',
			headerName: 'Chart Name',
			minWidth: 270,
			width: 270,
			maxWidth: 270,
		},
		{
			field: 'show',
			headerName: 'Action',
			minWidth: 120,
			width: 120,
			maxWidth: 120,
			cellRendererFramework: params => (
				<>
					<ApToggleSwitch
						color={colors.green100}
						checked={params.value}
						onChange={() => toggleValue(params.data.key)}
					/>
				</>
			),
		},
	];

	const getGridOptions = () => {
		return {
			modules: AllModules,
			defaultColDef: {
				suppressMenu: true,
				flex: 1,
				comparator: () => 0,
			},
			rowData: chartsOption,
			rowHeight: ROW_HEIGHT,
			headerHeight: HEADER_HEIGHT,
			columnDefs,
			suppressCopyRowsToClipboard: true,
			suppressScrollOnNewData: true,
			suppressRowDrag: true,
			suppressRowClickSelection: true,
			suppressCellSelection: true,
			suppressCsvExport: true,
			suppressExcelExport: true,
			suppressContextMenu: true,
			suppressMultiSort: true,
			applyColumnDefOrder: true,
			domLayout: 'autoHeight',
			onGridReady: onGridReady,
			onRowDataChanged: params => {
				params.api.sizeColumnsToFit();
			},
		};
	};
	const handleOnSave = async () => {
		const resultObject = {};

		chartsOption.forEach(chart => {
			resultObject[chart.settingsKey] = chart.show;
		});
		updateCategoryInsightSettings(resultObject, 'dashboardSettings');
		setIsSettingSidebar(false);
		handleSaveDashboardSettings(chartsOption);
	};

	const isAnyChartLoading = useMemo(
		() =>
			spendBySubCategoryLoading ||
			vendorsBySpendLoading ||
			spendByCountryLoading ||
			vendorSpendByCategoryLoading ||
			vendorParetoContextLoading ||
			supplierLandscapeLoading ||
			spendByBusinessUnitLoading ||
			spendByCostCenterLoading ||
			daysPaidOutstandingLoading ||
			spendOverTimeLoading ||
			paymentTermSupplierLoading ||
			commonSuppliersLoading
				? true
				: false,
		[
			spendBySubCategoryLoading,
			vendorsBySpendLoading,
			spendByCountryLoading,
			vendorSpendByCategoryLoading,
			vendorParetoContextLoading,
			supplierLandscapeLoading,
			spendByBusinessUnitLoading,
			spendByCostCenterLoading,
			daysPaidOutstandingLoading,
			spendOverTimeLoading,
			paymentTermSupplierLoading,
			commonSuppliersLoading,
		]
	);

	return (
		<Wrapper>
			<Ribbon>
				<ApButtonIcon
					title="Add Category"
					iconName="add"
					iconProps={{ iconColor: colors.grey8 }}
					onClick={() => setIsCategorySidebar(true)}
				/>
				<RibbonText>
					{currentSelectCategory.categoryName === allOption.id ? (
						<>Category - All</>
					) : (
						<>
							L{decodeURI(currentSelectCategory.categoryName).split('/')
								.length - 2}
							Category -{' '}
							{decodeURIComponent(
								decodeURI(currentSelectCategory.categoryName).split('/')[
									decodeURI(currentSelectCategory.categoryName).split('/')
										.length - 2
								]
							)}
						</>
					)}
				</RibbonText>
				{!isAnyChartLoading ? (
					<>
						<DirectIndirectOptionsWrapper>
							<ApSimpleDropdown
								options={DirectIndirectOptions}
								selected={
									DirectIndirectOptions.filter(x => x.value === isDirect)?.[0]
								}
								onChange={e => handleDirectIndirectChange(e.value)}
							/>
						</DirectIndirectOptionsWrapper>
						<SourceableTotalSpendOptionWrapper>
							<ApSimpleDropdown
								options={SourceableTotalSpendOptions}
								selected={
									SourceableTotalSpendOptions.filter(
										x => x.value === isSourceable
									)?.[0]
								}
								onChange={e => handleSourceableTotalSpendChange(e.value)}
							/>
						</SourceableTotalSpendOptionWrapper>
						<TaxonomyTypeOptionWrapper>
							<ApSimpleDropdown
								options={
									isDirect === false
										? DirectTaxonomyTypeOptions
										: IndirectTaxonomyTypeOptions
								}
								selected={
									isDirect === false
										? DirectTaxonomyTypeOptions[0]
										: IndirectTaxonomyTypeOptions.filter(
												x => x.value === taxonomyType
										  )
								}
								onChange={e => handleTaxonomyTypeChange(e.value)}
							/>
						</TaxonomyTypeOptionWrapper>
						<DateRangeWrapper>
							{!isUndefined(dateRangeData) && (
								<MonthPicker
									srcRange={dateRangeData.srcRange}
									stateRange={dateRangeData.stateRange}
									onConfirm={handleDateRangeChange}
								/>
							)}
						</DateRangeWrapper>
					</>
				) : (
					<div style={{ margin: '0 0 0 auto' }} />
				)}

				<ToggleWrapper>
					<div>
						<ApButtonIcon
							title={`Settings`}
							iconName="baseline_tune"
							onClick={() => setIsSettingSidebar(true)}
						/>
					</div>
					<div>
						<ApButtonIcon
							title={`Filters`}
							iconName="settings"
							onClick={() => setIsFilterSidebar(true)}
						/>
					</div>
				</ToggleWrapper>
			</Ribbon>

			<ToggleSidebar
				key={0}
				id={0}
				name={'category'}
				heading={'Categories'}
				show={isCategorySidebar}
				handleClose={setIsCategorySidebar}
				width={'24%'}
				toRight={false}
			>
				<CategorySidebarContent />
			</ToggleSidebar>

			<ToggleSidebar
				key={1}
				id={1}
				name={'settings'}
				heading={'Settings'}
				show={isSettingSidebar}
				handleClose={setIsSettingSidebar}
				width={'30%'}
				toRight={true}
			>
				<TableWrapper>
					<div className="ag-theme-balham">
						<AgGridReact {...getGridOptions()} />
					</div>
				</TableWrapper>
				<ButtonWrapper>
					<ApButtonSecondary onClick={handleOnSave} small width={100}>
						Save
					</ApButtonSecondary>
				</ButtonWrapper>
			</ToggleSidebar>

			<ToggleSidebar
				key={2}
				id={2}
				name={'filter'}
				heading={'Charts Filter'}
				show={isFilterSidebar}
				handleClose={setIsFilterSidebar}
				width={'30%'}
				toRight={true}
				showOverflow={true}
			>
				<FiltersWrapper>
					<SupplierLandscapeFilter>
						<p>Supplier Landscape</p>
						<div>
							<InputWrapper>
								<Select
									tooltipText="This represents Sub-Category level (L1/L2/L3/L4) for which we want to see the Supplier Landscape."
									name="categoryName"
									label="Category"
									options={
										taxonomyType === TAXONOMY_TYPES.CLIENT
											? AP_CATEGORIES
											: CLIENT_CATEGORIES
									}
									value={
										taxonomyType === TAXONOMY_TYPES.CLIENT
											? AP_CATEGORIES.find(item => item.key === category)
													?.value || APCategoryMapper.L4
											: CLIENT_CATEGORIES.find(item => item.key === category)
													?.value || ClientCategoryMapper.L4
									}
									onChange={changeCategory}
								/>
							</InputWrapper>
							<SmallInputWrapper>
								<Label>
									Spend Threshold
									<Tooltip
										position="top"
										animation="fade"
										arrow
										html={
											<TooltipContent>
												This represents the spend value threshold to calculate
												the supplier landscape.
											</TooltipContent>
										}
										trigger="mouseenter"
									>
										<ApIcon
											iconName="baseline_help"
											iconSize={11}
											iconColor={colors.grey6}
										/>
									</Tooltip>
								</Label>
								<ApInput
									type="number"
									name="categoryValue"
									onChange={changeCategory}
									value={value}
								/>
							</SmallInputWrapper>
							<InputWrapper>
								<Select
									tooltipText="This represents the scale of spend threshold (Thousand/Million/Billion)."
									name="categoryUnit"
									label="Unit"
									options={UNITS}
									value={UNITS.find(item => item.key === unit).value}
									onChange={changeCategory}
								/>
							</InputWrapper>
						</div>
					</SupplierLandscapeFilter>
					<SupplierLandscapeFilter>
						<p>Custom Chart</p>
						<div>
							{customFiters.length > 0 && (
								<InputWrapper>
									<Select
										tooltipText="This represents Custom Columns Present in Database"
										name="categoryName"
										label="Custom Column Name"
										options={customFiters}
										value={
											customFiters.find(
												item => item.key === Number(customColId)
											).value || DEFAULT_CUSTOM_COLUMNS
										}
										onChange={e =>
											setCustomColumnID(
												customFiters.find(item => item.value === e.target.value)
													.key
											)
										}
									/>
								</InputWrapper>
							)}
						</div>
					</SupplierLandscapeFilter>
					<SpendByYearFilter>
						<p>Spend By Year</p>
						<DateRangeWrapperSpendByYear>
							{!isUndefined(dateRangeDataSpendByYear) && (
								<MonthPicker
									srcRange={dateRangeDataSpendByYear.srcRange}
									stateRange={dateRangeDataSpendByYear.stateRange}
									onConfirm={handleDateRangeChangeForSpendByYear}
								/>
							)}
						</DateRangeWrapperSpendByYear>
					</SpendByYearFilter>
				</FiltersWrapper>
			</ToggleSidebar>

			{data.totalSpend === '$0.00' ? (
				<NoDataWrapper>
					<NoData
						title="No data available for this combination of filters"
						msg="Please try to  change the filter options"
					/>
				</NoDataWrapper>
			) : (
				<>
					<KpiGridContainer>
						<KpiList />
					</KpiGridContainer>

					{spendBySubCategoryLoading ||
					vendorsBySpendLoading ||
					spendByCountryLoading ||
					vendorSpendByCategoryLoading ||
					vendorParetoContextLoading ||
					supplierLandscapeLoading ||
					spendByBusinessUnitLoading ||
					spendByCostCenterLoading ||
					daysPaidOutstandingLoading ||
					spendOverTimeLoading ||
					paymentTermSupplierLoading ||
					commonSuppliersLoading ||
					dashBoardSettings === null ? (
						<LoadingIndicator loading />
					) : (
						<ChartsWrapper
							chartheight={'60%'}
							chartsOption={chartsOption}
							category={currentSelectCategory.categoryName}
						/>
					)}
				</>
			)}
		</Wrapper>
	);
};

export default Dashboard;
